import { render, staticRenderFns } from "./OrderPoundBill.vue?vue&type=template&id=24cc3c1d&scoped=true"
import script from "./OrderPoundBill.vue?vue&type=script&lang=js"
export * from "./OrderPoundBill.vue?vue&type=script&lang=js"
import style0 from "./OrderPoundBill.vue?vue&type=style&index=0&id=24cc3c1d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cc3c1d",
  null
  
)

export default component.exports